'use strict';

function MarketingSignUpLogInAppDescription() {
  this.id = null;
  this.node = null;

  this.el = {};

  this._classes = {
    signUpHeaderDescription: 'js--signup-app-header-description',
    signUpDescription: 'js--signup-app-description',
    logInDescription: 'js--login-app-description'
  };

  this.init = function () {};

  this.initAllReady = function () {
    this.el.$signUpHeaderDescription = $('.' + this._classes.signUpHeaderDescription);
    this.el.$signUpDescription = $('.' + this._classes.signUpDescription);
    this.el.$logInDescription = $('.' + this._classes.logInDescription);
    this._signUpHeaderDescription();
    this._signUpDescription();
  };

  this._signUpHeaderDescription = function () {
    // disable extra contentful calls until we need them:
    $(this.node).find(this.el.$signUpHeaderDescription).text('No credit impact.');
  };
  this._signUpDescription = function () {
    var _this = this;

    // MKTG-375: read sign-up description from local snapshot.
    ContentSnapshots.load('entry-signUpDescription').done(function (contentfulData) {
      _this.contentfulData = contentfulData.items[0].value;
      $(_this.node).find(_this.el.$signUpDescription).text(_this.contentfulData);
    });
  };
}